/*
 * Smoothly animates the cart free shipping progress bar when the cart drawer
 * re-renders (e.g. after changing product quantity).
 *
 * The drawer replaces the innerHTML of #CartDrawer on every update, so the
 * freshly rendered fill already starts at its final width and the CSS
 * transition never fires. This script remembers the previous progress, sets
 * the new bar back to that value, then animates it to the real target so the
 * `transition: width` on the fill kicks in.
 */
(function () {
  'use strict';

  var lastProgress = null;

  function getTarget(bar) {
    return parseFloat(bar.getAttribute('data-progress') || '0');
  }

  function animate(container) {
    var bar = container.querySelector('.cart-free-shipping');

    // No bar (empty cart): reset so the next render starts fresh, no animation.
    if (!bar) {
      lastProgress = null;
      return;
    }

    var fill = bar.querySelector('.cart-free-shipping__fill');
    var target = getTarget(bar);

    // First time we see the bar, no change, or no WAAPI: just record it.
    if (lastProgress === null || target === lastProgress || !fill || !fill.animate) {
      lastProgress = target;
      return;
    }

    var from = lastProgress;
    lastProgress = target;

    // The bar is re-rendered fresh on every cart update (innerHTML swap), so a
    // CSS transition can't fire — there is no "before" state. Explicitly tween
    // the fill width from the previous value to the new one. It settles back to
    // the CSS-var width (= target) once the animation ends.
    fill.animate(
      [{ width: from + '%' }, { width: target + '%' }],
      { duration: 450, easing: 'ease' }
    );
  }

  function init() {
    var cartDrawer = document.getElementById('CartDrawer');
    if (!cartDrawer) return;

    var initialBar = cartDrawer.querySelector('.cart-free-shipping');
    if (initialBar) lastProgress = getTarget(initialBar);

    // #CartDrawer persists across re-renders; only its innerHTML is swapped.
    var observer = new MutationObserver(function () {
      animate(cartDrawer);
    });
    observer.observe(cartDrawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
